import { useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import client from './shopify/client';
import { NEWSLETTER_SIGNUP } from './shopify/queries';

function App() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'exists' | 'error'

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim() || status === 'loading') return;
        setStatus('loading');

        const password = `nl_${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;

        try {
            const { data } = await client.request(NEWSLETTER_SIGNUP, {
                variables: { email: email.trim(), password },
            });

            const errors = data?.customerCreate?.customerUserErrors ?? [];
            const alreadyExists = errors.some((e) => e.code === 'TAKEN');

            if (data?.customerCreate?.customer) {
                setStatus('success');
            } else if (alreadyExists) {
                setStatus('exists');
            } else {
                setStatus('error');
            }
        } catch {
            setStatus('error');
        }
    };

    return (
        <div className="App">
            <img src="/2B55699D-C82C-4115-9771-14E9E64B1981.png" className="brand-logo" alt="logo" draggable="false" />
            <p className="headline">
                THE MOVEMENT
                <br />
                STARTS SOON.
            </p>

            <div className="newsletter-wrap">
                {status === 'success' ? (
                    <p className="newsletter-success">Du wirst als Erstes informiert.</p>
                ) : (
                    <form className="newsletter-form" onSubmit={handleSubmit} noValidate>
                        <input
                            className="newsletter-input"
                            type="email"
                            placeholder="DEINE E-MAIL"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setStatus(null);
                            }}
                            required
                            disabled={status === 'loading'}
                        />
                        <button className="newsletter-btn" type="submit" disabled={status === 'loading'}>
                            {status === 'loading' ? '...' : 'NOTIFY ME'}
                        </button>
                        {status === 'exists' && <p className="newsletter-hint">Du bist bereits eingetragen.</p>}
                        {status === 'error' && <p className="newsletter-hint">Bitte gültige E-Mail eingeben.</p>}
                    </form>
                )}
            </div>

            <Link to="/impressum" className="impressum-link">
                Impressum
            </Link>
        </div>
    );
}

export default App;
